export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_CONTENT: 204,
    MOVED_PERMANENTLY: 301,
    FOUND: 302,
    NOT_MODIFIED: 304,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    METHOD_NOT_ALLOWED: 405,
    CONFLICT: 409,
    PAYLOAD_TOO_LARGE: 413,
    UNSUPPORTED_MEDIA_TYPE: 415,
    UNPROCESSABLE_ENTITY: 422,
    TOO_MANY_REQUESTS: 429,
    INTERNAL_SERVER_ERROR: 500,
    NOT_IMPLEMENTED: 501,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
};
export const ERROR_MESSAGES = {
    NETWORK_ERROR: 'Network error. Please check your connection.',
    TIMEOUT_ERROR: 'Request timeout. Please try again.',
    UNAUTHORIZED: 'Authentication required. Please log in.',
    FORBIDDEN: "Access denied. You don't have permission to perform this action.",
    NOT_FOUND: 'The requested resource was not found.',
    BAD_REQUEST: 'Invalid request. Please check your data.',
    CONFLICT: 'This resource already exists or conflicts with existing data.',
    UNPROCESSABLE_ENTITY: 'Invalid data provided. Please check your input.',
    TOO_MANY_REQUESTS: 'Too many requests. Please wait before trying again.',
    INTERNAL_SERVER_ERROR: 'Server error. Please try again later.',
    SERVICE_UNAVAILABLE: 'Service temporarily unavailable. Please try again later.',
    UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
};
export const TIMEOUTS = {
    DEFAULT: 30000,
    LONG_RUNNING: 60000,
    UPLOAD: 120000,
    DOWNLOAD: 300000,
    FAST: 10000,
};
export const RETRY_CONFIG = {
    MAX_RETRIES: 3,
    DELAY: 1000,
    BACKOFF_FACTOR: 2,
};
export const CONTENT_TYPES = {
    JSON: 'application/json',
    FORM_DATA: 'multipart/form-data',
    URL_ENCODED: 'application/x-www-form-urlencoded',
    TEXT: 'text/plain',
    HTML: 'text/html',
    XML: 'application/xml',
    PDF: 'application/pdf',
};
export const HEADERS = {
    ACCEPT: 'Accept',
    AUTHORIZATION: 'Authorization',
    CONTENT_TYPE: 'Content-Type',
    USER_AGENT: 'User-Agent',
    X_REQUESTED_WITH: 'X-Requested-With',
    CACHE_CONTROL: 'Cache-Control',
};
export const AUTH = {
    TOKEN_TYPE: 'Bearer',
    LOGIN_ENDPOINT: '/auth/login',
    LOGOUT_ENDPOINT: '/auth/logout',
};
export const EVENTS = {
    AUTH_LOGOUT: 'auth:logout',
    AUTH_LOGIN: 'auth:login',
    API_ERROR: 'api:error',
};
